<div class="breadcrumb-container" *ngIf="(breadcrumbs$ | async)?.length">
  <nav class="breadcrumb" >
    @for (item of breadcrumbs$ | async ; track item; let last = $last ) {
    <button class="breadcrumb-menu" (click)="onBreadcrumbClick(item)"
      [class.active]="(activeBreadcrumb$ | async) === item">{{ item }}</button>
    <span *ngIf="!last"> <mat-icon class="chevron">chevron_right</mat-icon> </span>
    }
  </nav>
</div>